import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import { MinusIcon, PlusIcon } from 'components/Icons'

import { Body16, Body14 } from 'components/Typography'
import {
  InputQuantity,
  QuantityButton,
  ItemWrapper,
  InputWrapper,
  LabelWrapper,
} from './FormQuantitySelector.style'

const FormQuantitySelectorItem = ({
  handleChange,
  handleDecrement,
  handleIncrement,
  value,
  title,
  description,
  required,
  hasError,
  isDisabled,
}) => {
  return (
    <ItemWrapper>
      <LabelWrapper isDisabled={isDisabled} hasError={hasError}>
        <Body16 as="div" color={theme.colors.sagedark}>
          {title}
        </Body16>
        <Body14 as="div" color={theme.colors.sagemedium}>
          {description}
        </Body14>
      </LabelWrapper>

      <InputWrapper>
        <QuantityButton
          hasError={hasError}
          isDisabled={isDisabled}
          onClick={handleDecrement}>
          <MinusIcon
            width={[32]}
            color={value > 0 ? theme.colors.sagedark : theme.colors.sagelight}
          />
        </QuantityButton>

        <InputQuantity
          type="number"
          value={value}
          onChange={handleChange}
          required={required}
          hasError={hasError}
          isDisabled={isDisabled}
          readOnly
        />

        <QuantityButton
          hasError={hasError}
          isDisabled={isDisabled}
          onClick={handleIncrement}>
          <PlusIcon
            width={[32]}
            color={value < 10 ? theme.colors.sagedark : theme.colors.sagelight}
          />
        </QuantityButton>
      </InputWrapper>
    </ItemWrapper>
  )
}

FormQuantitySelectorItem.propTypes = {
  required: PropTypes.bool,
  isDisabled: PropTypes.bool,
  hasError: PropTypes.bool,
  handleChange: PropTypes.func,
  handleDecrement: PropTypes.func.isRequired,
  handleIncrement: PropTypes.func.isRequired,
  value: PropTypes.number,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

FormQuantitySelectorItem.defaultProps = {
  handleChange: null,
  required: false,
  isDisabled: false,
  hasError: false,
  value: 0,
}

export default FormQuantitySelectorItem
